import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-success mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "flex-center py-10"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { class: "s20 widget p-6 mb-5" }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","gap":"1.5rem"} }
const _hoisted_8 = { style: {"width":"96px","height":"96px","min-width":"96px","flex":"0 0 96px","border-radius":"15px","overflow":"hidden"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"flex":"1 1 auto","min-width":"0"} }
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "flex gap-3" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "s20 widget p-6 mb-5" }
const _hoisted_16 = { class: "flex-right mt-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "mb-5",
  style: {"display":"flex","gap":"1.5rem","flex-wrap":"wrap","align-items":"flex-start","clear":"both"}
}
const _hoisted_19 = {
  class: "widget p-6",
  style: {"flex":"1 1 calc(50% - 0.75rem)","min-width":"320px"}
}
const _hoisted_20 = {
  class: "widget p-6",
  style: {"flex":"1 1 calc(50% - 0.75rem)","min-width":"320px"}
}
const _hoisted_21 = { class: "s20 widget p-6 mb-5" }
const _hoisted_22 = {
  key: 0,
  class: "text-grey-500 py-3"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { style: {"flex":"1 1 auto"} }
const _hoisted_25 = {
  key: 0,
  class: "ml-2 text-sm text-grey-500"
}
const _hoisted_26 = {
  key: 1,
  class: "ml-2 text-sm text-grey-500"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = ["disabled", "onClick"]

import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import OnboardingPersonalInfosForm from '@/components/collectivites/onboarding/OnboardingPersonalInfosForm.vue'
import OnboardingIdentityDocumentsForm from '@/components/collectivites/onboarding/OnboardingIdentityDocumentsForm.vue'
import OnboardingPayslipDocumentsForm from '@/components/collectivites/onboarding/OnboardingPayslipDocumentsForm.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'KycMembreDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const submitting = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
const detail = ref<any>(null)
const collectivites = ref<Array<{ id: number; nom: string }>>([])
const personalFormRef = ref<any>(null)

const typesPieceIdentites: Record<string, string> = {
  '1': 'CNI',
  '2': 'Passeport',
}

async function fetchDetail() {
  loading.value = true
  errorMessage.value = ''
  try {
    const { data } = await axios.get(`/kyc/members/${route.params.id}`)
    detail.value = data
    if (data?.user?.collectivite) {
      collectivites.value = [{ id: data.user.collectivite.id, nom: data.user.collectivite.nom }]
    } else if (data?.user?.collectivite_id) {
      collectivites.value = [{ id: data.user.collectivite_id, nom: 'Collectivité' }]
    }
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors du chargement'
  } finally {
    loading.value = false
  }
}

const personalInitialData = computed(() => {
  const u = detail.value?.user
  if (!u) return null
  const k = detail.value?.kyc
  return {
    nom: k?.nom ?? u.nom ?? '',
    prenom: k?.prenom ?? u.prenom ?? '',
    date_naissance: (k?.date_naissance ?? u.date_naissance)
      ? String(k?.date_naissance ?? u.date_naissance).substring(0, 10)
      : '',
    age: u.age ?? 0,
    date_engagement: u.date_engagement ? String(u.date_engagement).substring(0, 10) : '',
    anciennete: u.anciennete ?? 0,
    collectivite_id: u.collectivite_id ?? null,
    salaire: u.salaire != null ? String(u.salaire) : '',
    quotite_cessible_pourcent: u.quotite_cessible_pourcent != null ? String(u.quotite_cessible_pourcent) : '',
    quotite_cessible_montant: u.quotite_cessible_montant != null ? String(u.quotite_cessible_montant) : '',
    telephone: u.telephone ?? '',
    email: u.email ?? '',
  }
})

async function onPersonalFormSaved(payload: any) {
  submitting.value = true
  errorMessage.value = ''
  successMessage.value = ''
  try {
    await axios.put(`/kyc/members/${route.params.id}`, {
      nom: payload.nom,
      prenom: payload.prenom,
      date_naissance: payload.date_naissance,
    })
    successMessage.value = 'Profil KYC enregistré'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de la sauvegarde'
  } finally {
    submitting.value = false
  }
}

function triggerSavePersonal() {
  personalFormRef.value?.onSubmit()
}

async function uploadKycDocument(typeDocument: string, file: any, extra: { numero?: string; expiration?: string } = {}) {
  const fd = new FormData()
  fd.append('type_document', typeDocument)
  fd.append('fichier', file)
  if (extra.numero) fd.append('numero', extra.numero)
  if (extra.expiration) fd.append('expiration', extra.expiration)
  await axios.post(`/kyc/members/${route.params.id}/documents`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

async function onIdentityDocumentsSaved(payload: any) {
  submitting.value = true
  errorMessage.value = ''
  successMessage.value = ''
  try {
    const typeLabel = typesPieceIdentites[payload.type_piece_identite] || 'cni'
    const isPassport = String(typeLabel).toLowerCase().includes('pass')

    if (payload.photo?.file) {
      await uploadKycDocument('photo', payload.photo.file)
    }
    if (payload.piece_recto?.file) {
      await uploadKycDocument(isPassport ? 'passeport' : 'cni_recto', payload.piece_recto.file, {
        numero: payload.numero_piece_identite,
      })
    }
    if (payload.piece_verso?.file && !isPassport) {
      await uploadKycDocument('cni_verso', payload.piece_verso.file, {
        numero: payload.numero_piece_identite,
      })
    }
    successMessage.value = "Pièces d'identité enregistrées"
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || "Erreur lors de l'enregistrement des pièces"
  } finally {
    submitting.value = false
  }
}

const lastUploadedBulletins = ref<Record<string, string>>({})

async function onPayslipDocumentsSaved(payload: any) {
  // Le composant frontoffice émet 'saved' à chaque upload — on upload uniquement le bulletin nouvellement ajouté
  for (const key of ['bulletin1', 'bulletin2', 'bulletin3'] as const) {
    const item = payload[key]
    if (item?.file && lastUploadedBulletins.value[key] !== item.name) {
      submitting.value = true
      errorMessage.value = ''
      try {
        await uploadKycDocument(key, item.file)
        lastUploadedBulletins.value[key] = item.name
        successMessage.value = `Bulletin ${key.replace('bulletin', '')} enregistré`
      } catch (e: any) {
        errorMessage.value = e.response?.data?.message || "Erreur lors de l'upload du bulletin"
      } finally {
        submitting.value = false
      }
    }
  }
  await fetchDetail()
}

async function validateKyc() {
  if (!confirm('Confirmer la validation du KYC de ce membre ?')) return
  submitting.value = true
  errorMessage.value = ''
  try {
    await axios.post(`/kyc/members/${route.params.id}/validate`)
    successMessage.value = 'KYC validé'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de la validation'
  } finally {
    submitting.value = false
  }
}

async function rejectKyc() {
  if (!confirm('Confirmer le rejet du KYC de ce membre ?')) return
  submitting.value = true
  errorMessage.value = ''
  try {
    await axios.post(`/kyc/members/${route.params.id}/reject`)
    successMessage.value = 'KYC rejeté'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors du rejet'
  } finally {
    submitting.value = false
  }
}

async function deleteDocument(docId: number) {
  if (!confirm('Supprimer ce document ?')) return
  submitting.value = true
  try {
    await axios.delete(`/kyc/members/${route.params.id}/documents/${docId}`)
    successMessage.value = 'Document supprimé'
    await fetchDetail()
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors de la suppression'
  } finally {
    submitting.value = false
  }
}

function statutLabel(): { label: string; cls: string } {
  const s = detail.value?.kyc?.statut
  if (!detail.value?.kyc) return { label: 'Pas de KYC', cls: 'tag-state warning stroke' }
  if (s === 'verified') return { label: 'Validé', cls: 'tag-state success stroke' }
  if (s === 'rejected') return { label: 'Rejeté', cls: 'tag-state danger stroke' }
  return { label: 'En attente', cls: 'tag-state warning stroke' }
}

onMounted(fetchDetail)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn white2 mb-4",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
    }, "← Retour"),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : (detail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: detail.value.user.photo_url || '/public/assets/users/300w/user2.jpg',
                    style: {"width":"100%","height":"100%","object-fit":"cover","display":"block"}
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", null, _toDisplayString(detail.value.user.nom) + " " + _toDisplayString(detail.value.user.prenom), 1),
                  _createElementVNode("p", null, _toDisplayString(detail.value.user.email), 1),
                  _createElementVNode("p", null, _toDisplayString(detail.value.user.telephone), 1),
                  _createElementVNode("p", _hoisted_11, [
                    _cache[2] || (_cache[2] = _createTextVNode(" Statut KYC : ", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(statutLabel().cls)
                    }, _toDisplayString(statutLabel().label), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "btn-ultra",
                    disabled: submitting.value || !detail.value.kyc,
                    onClick: validateKyc
                  }, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-valider.svg",
                        class: "btn-icon icon-neutral",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Valider")
                    ], -1)
                  ]))], 8, _hoisted_13),
                  _createElementVNode("button", {
                    class: "btn-ultra danger",
                    disabled: submitting.value || !detail.value.kyc,
                    onClick: rejectKyc
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/public/icons/icon-denied.svg",
                        class: "btn-icon icon-white",
                        alt: ""
                      }),
                      _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Rejeter")
                    ], -1)
                  ]))], 8, _hoisted_14)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-4" }, "Profil KYC", -1)),
              _createVNode(OnboardingPersonalInfosForm, {
                ref_key: "personalFormRef",
                ref: personalFormRef,
                collectivites: collectivites.value,
                "hide-collectivite-field": true,
                "hide-submit-button": true,
                "initial-data": personalInitialData.value,
                onSaved: onPersonalFormSaved
              }, null, 8, ["collectivites", "initial-data"]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "btn-ultra",
                  disabled: submitting.value,
                  onClick: triggerSavePersonal
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-valider.svg",
                      class: "btn-icon icon-neutral",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Enregistrer")
                  ], -1)
                ]))], 8, _hoisted_17)
              ])
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "mb-4" }, "Pièce d'identité", -1)),
                _createVNode(OnboardingIdentityDocumentsForm, {
                  user: { nom: detail.value.user.nom, prenom: detail.value.user.prenom, email: detail.value.user.email, telephone: detail.value.user.telephone },
                  types_piece_identites: typesPieceIdentites,
                  "hide-header": true,
                  onSaved: onIdentityDocumentsSaved
                }, null, 8, ["user"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "mb-4" }, "Bulletins de salaire", -1)),
                _createVNode(OnboardingPayslipDocumentsForm, {
                  "form-params": { user: detail.value.user, photo: null },
                  loading: submitting.value,
                  "hide-header": true,
                  "hide-title": true,
                  "hide-previous-link": true,
                  onSaved: onPayslipDocumentsSaved
                }, null, 8, ["form-params", "loading"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "mb-4" }, "Documents existants", -1)),
              (!detail.value.kyc?.documents?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Aucun document fourni. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.kyc.documents, (d) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: d.id,
                        class: "flex align-items-center gap-4 py-3 border-bottom"
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("strong", null, _toDisplayString(d.typeDocument), 1),
                          (d.numero)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "N° " + _toDisplayString(d.numero), 1))
                            : _createCommentVNode("", true),
                          (d.expiration && d.expiration !== '--')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Exp. " + _toDisplayString(d.expiration.substring(0, 10)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (d.fichierUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: d.fichierUrl,
                              target: "_blank",
                              class: "btn white2"
                            }, "Voir", 8, _hoisted_27))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "btn-ultra danger",
                          disabled: submitting.value,
                          onClick: ($event: any) => (deleteDocument(d.id))
                        }, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("div", { class: "btn-show" }, [
                            _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Supprimer")
                          ], -1)
                        ]))], 8, _hoisted_28)
                      ]))
                    }), 128))
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})